import Card from "./card.js";
export default class ClassicCard extends Card {
  constructor(s, t, i, h, r, c, e, a, o, d, l, n, u, p, f, m) {
    super(s, t, i, h, r, c, e, a, o, d, l, n, u, p, f, m),
      (this.oe = "ab-classic-card"),
      (this.ae = !0);
  }
  bt() {
    const s = {};
    return (
      (s[Card.es.hs] = Card.cs.Ii),
      (s[Card.es.ds] = this.id),
      (s[Card.es.ps] = this.viewed),
      (s[Card.es.us] = this.title),
      (s[Card.es.ls] = this.imageUrl),
      (s[Card.es.fs] = this.description),
      (s[Card.es.xs] = this.updated),
      (s[Card.es.bs] = this.created),
      (s[Card.es.gs] = this.categories),
      (s[Card.es.js] = this.expiresAt),
      (s[Card.es.URL] = this.url),
      (s[Card.es.zs] = this.linkText),
      (s[Card.es.ks] = this.aspectRatio),
      (s[Card.es.qs] = this.extras),
      (s[Card.es.vs] = this.pinned),
      (s[Card.es.ws] = this.dismissible),
      (s[Card.es.ys] = this.clicked),
      (s[Card.es.As] = this.test),
      s
    );
  }
}
